export default "__VITE_ASSET__BsNxZOZq__"